import React from "react";
import { Button, Container } from "react-bootstrap";
import { BsArrowRight } from "react-icons/bs";
import "./NewCollection.css";
import cat1 from "../../../images/categories/cat1.png";
import cat2 from "../../../images/categories/cat2.png";
import cat3 from "../../../images/categories/cat3.png";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
const NewCollection = () => {
  const categories = [
    {
      productId: 1,
      productImg: cat1,
      catName: "Pants",
    },
    {
      productId: 2,
      productImg: cat2,
      catName: "T-shirt",
    },
    {
      productId: 3,
      productImg: cat3,
      catName: "Shoe",
    },
    {
      productId: 4,
      productImg: cat1,
      catName: "Pants",
    },
    {
      productId: 5,
      productImg: cat2,
      catName: "T-shirt",
    },
    {
      productId: 6,
      productImg: cat3,
      catName: "Shoe",
    },
  ];
  return (
    <div className="section-container">
      <Container>
        <div className="row align-items-center">
          <div className="col-12 col-md-6">
            <img
              src={require("../../../images/new-collection/collection1.png")}
              alt=""
              className="w-100"
            />
          </div>
          <div className="col-12 col-md-6">
            <div className="section-heading">
              <span>New Collection</span>
              <h2>Grab Our New Collection Now</h2>
              <p>
                Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                Voluptates, dolorum minima nulla nemo quam tempore officia rerum
                doloribus provident maxime eveniet porro cumque aliquam odit
                natus dolore, laudantium temporibus numquam, perspiciatis
                accusantium animi voluptatibus! Voluptates.
              </p>
              <Button className="btn-light">
                Buy Now
                <BsArrowRight className="ms-2" />
              </Button>
            </div>
            <div className="collection-slider">
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. <br />{" "}
                Cupiditate quas necessitatibus consequuntur.
              </p>
            <div className="mt-2">
            <Swiper
                slidesPerView={1}
                spaceBetween={10}
                navigation={false}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                breakpoints={{
                  640: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                  768: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                  },
                  1024: {
                    slidesPerView: 5,
                    spaceBetween: 10,
                  },
                }}
                className="mySwiper3"
              >
                {categories.map((cat, y) => (
                  <SwiperSlide key={y}>
                    <div className="category text-center">
                      <div className="collection-image">
                        <img src={cat.productImg} alt="" className="w-100 h-100" />
                      </div>
                      <h6 className="fw-light">{cat.catName}</h6>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default NewCollection;
